import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSV_FROM } from '../../util/enums/EnumLayers';
import { uploadCsv } from '../../actions';
import ModalLoading from './ModalLoading';

class ModalCsvUpload extends Component {
  static modalType() {
    return CSV_FROM;
  }

  static reducer(modals) {
    return modals.csvUploadModal;
  }

  static title() {
    return <span>Start from CSV</span>;
  }

  render() {
    const { state, onFileUpload } = this.props;

    const fileProvided = (e) => {
      const size = e.currentTarget.files[0].size / 1024 / 1024;
      const form = document.getElementById('csv-upload-form');
      const formData = new FormData(form);
      onFileUpload(formData, size);
    };

    return (
      <div className="upload-csv">
        <form
          id="csv-upload-form"
          method="POST"
          action="/upload"
          encType="multipart/form-data"
        >
          <input
            disabled={state.loading}
            onChange={fileProvided}
            type="file"
            name="file"
          />
          {!state.errorMsg ? null : (
            <div className="alert alert-danger" role="alert">
              {state.errorMsg}
            </div>
          )}
          {!state.csvUploadId ? null : (
            <div className="alert alert-success" role="alert">
              CSV ready
            </div>
          )}
          {!state.loading ? null : <ModalLoading />}
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFileUpload: (formData, size) => {
      dispatch(uploadCsv(formData, size));
    },
  };
};

export default connect(null, mapDispatchToProps)(ModalCsvUpload);
